import { Checkbox, Input, List, Space, Typography } from 'antd'
import { usePDFDesignLayersContext } from '../../../../PDFDesignLayersContext'
import { ProjectLayersInputProps } from './types'
import { useState } from 'react'
import { MapServerLayer } from '../../../../PDFDesignLayersContext/types'
import ProjectLink from 'components/ProjectLink'
import { CIMSPage } from '@cims-online/shared'

const ProjectLayersInput: React.VFC<ProjectLayersInputProps> = ({
  value,
  onChange,
}) => {
  const { projectLayers } = usePDFDesignLayersContext()
  const [dataSource, setDataSource] = useState<MapServerLayer[]>(
    projectLayers.data?.project.projectMetadata?.mapServerLayers ?? []
  )
  return projectLayers.data &&
    !projectLayers.data.project.projectMetadata?.mapServerLayers.length ? (
    <Space direction="vertical">
      <Typography.Text>
        There are no project layers for this project.{' '}
      </Typography.Text>
      <Typography.Text>
        Is the CM Project Layer configured in the project{' '}
        <ProjectLink item={CIMSPage.ProjectSettings}>settings</ProjectLink>?
      </Typography.Text>
    </Space>
  ) : (
    <>
      <Input
        onChange={({ target: { value } }) =>
          setDataSource(
            (
              projectLayers.data?.project.projectMetadata?.mapServerLayers ?? []
            ).filter(({ name }) =>
              name.toLowerCase().includes(value.toLowerCase())
            )
          )
        }
        allowClear
        placeholder="Search"
        style={{ marginBottom: 8 }}
      />
      <List
        style={{ overflowY: 'scroll', maxHeight: 300 }}
        split={false}
        size="small"
        loading={projectLayers.loading}
        dataSource={dataSource}
        rowKey="id"
        renderItem={({ id, name }) => (
          <List.Item key={id}>
            <Checkbox
              checked={value?.includes(id)}
              onChange={(e) => {
                const set = new Set(value ?? [])
                const checked = e.target.checked
                if (checked) set.add(id)
                else set.delete(id)
                onChange?.([...set])
              }}
            >
              {name}
            </Checkbox>
          </List.Item>
        )}
      />
    </>
  )
}

export default ProjectLayersInput
